export default [
	{
		path: '/:subDomain/:venueChainId/qr/:qrCodeId',
		name: 'products-category-by-qr-code',
		beforeEnter: (to, from, next) => {
			const { subDomain, venueChainId, qrCodeId } = to.params
			next({
				params: {
					subDomain,
					venueChainId,
					qrCodeId
				},
				name: 'products-category'
			})
		},
		component: () => import('../../viewsOM/Products.vue')
	},
	{
		path: '/:subDomain/:venueChainId',
		component: () => import('../../viewsOM/Main.vue'),
		children: [
			{
				path: 'et/:eventTicketId',
				name: 'payment-method',
				component: () => import('../../viewsOM/PaymentMethod.vue')
			},
			{
				path: 'et-tab-template',
				name: 'event-ticket-tab-template',
				component: () => import('../../viewsOM/EventTicketTabTemplate.vue')
			},
			{
				path: 'cart',
				name: 'cart',
				component: () => import('../../viewsOM/Cart/Cart.vue')
			},
			{
				path: 'processing',
				name: 'processing',
				component: () =>
					import('../../viewsOM/CheckoutProcessing/CheckoutProcessing.vue')
			},
			{
				path: 'check',
				name: 'check',
				component: () => import('../../viewsOM/Check/Check.vue')
			},
			{
				path: 'schedule',
				name: 'schedule',
				component: () => import('../../viewsOM/Schedule.vue')
			},
			{
				path: '/',
				name: 'products',
				component: () => import('../../viewsOM/Products.vue'),
				children: [
					{
						path: ':category',
						name: 'products-category',
						component: () => import('../../viewsOM/ProductsByCategory.vue'),
						meta: { preserveScrollOnParamChange: true }
					}
				]
			}
		]
	},
	{
		path: '/404',
		name: 'notFound',
		component: () => import('../../viewsOM/NotFound')
	},
	{
		path: '*',
		redirect: '404'
	}
]
